import request from "./request"

export const privacyStatusGet = () => request.get("/privacy/status_get")
export const privacyCodeSend = data => request.post("/privacy/code_send", data)
export const privacyRequestCreate = data => request.post("/privacy/request_create", data)
export const privacyRecoveryCodeSend = data => request.post("/privacy-recovery/code_send", data)
export const privacyAccountDeleteCancel = data => request.post("/privacy-recovery/cancel", data)
